<template>
  <div class="avatar-menu-container">
    <a-dropdown placement="bottomRight">
      <div class="user-info">
        <a-avatar class="avatar" :src="userInfo.avatar_url" :size="32" />
        <div class="user-details">
          <span class="username">{{ userInfo.nickname }}</span>
          <a-icon class="dropdown-icon" type="caret-down" />
        </div>
      </div>
      <a-menu slot="overlay" class="dropdown-menu">
        <a-menu-item @click="toAboutPage">
          <div class="menu-item">
            <a-icon type="alert" />
            <span>关于我们</span>
          </div>
        </a-menu-item>
        <a-menu-item @click="onPersonal">
          <div class="menu-item">
            <a-icon type="user" />
            <span>个人中心</span>
          </div>
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item @click="onLogout">
          <div class="menu-item">
            <a-icon type="logout" />
            <span>退出登录</span>
          </div>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <personal-modal ref="personalRef" />
  </div>
</template>

<script>
import { getCookies, setCookies } from '@/utils/utils';
import { logout, verifyToken } from '@/api/system/auth';
import PersonalModal from '@/layouts/components/PersonalModal.vue';

export default {
  components: {
    PersonalModal
  },
  data() {
    return {
      userInfo: {}
    };
  },
  created() {
    const user_info = window.localStorage.getItem('user_info');
    if (user_info) {
      this.userInfo = JSON.parse(user_info);
    } else {
      verifyToken({ token: getCookies() }).then(res => {
        window.localStorage.setItem('user_info', JSON.stringify(res.data.user_info));
        this.userInfo = res.data.user_info;
      });
    }
  },

  methods: {
    onLogout() {
      logout({ token: getCookies() }).then(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user_info');
        localStorage.removeItem('refreshToken');
        setCookies('token'); // 清除token
        setCookies('refreshToken'); // 清除refreshToken
        window.location.href = process.env.VUE_APP_SSO_URL + '?url=' + window.location.href;
      });
    },
    onPersonal() {
      this.$refs.personalRef.onOpen();
    },
    toAboutPage() {
      this.$router.push('/about');
    }
  }
};
</script>

<style lang="less" scoped>
.avatar-menu-container {
  .user-info {
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 12px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
    color: rgba(0, 0, 0, 0.65);

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.85);
    }

    .avatar {
      margin-right: 8px;
      border: 2px solid #f0f0f0;
      transition: border-color 0.3s ease;
    }

    .user-details {
      display: flex;
      align-items: center;

      .username {
        font-size: 14px;
        font-weight: 500;
        margin-right: 4px;
        user-select: none;
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .dropdown-icon {
        font-size: 12px;
        transition: transform 0.3s ease;
      }
    }

    &:hover {
      .avatar {
        border-color: #1890ff;
      }

      .dropdown-icon {
        transform: rotate(180deg);
      }
    }
  }
}

.dropdown-menu {
  .menu-item {
    display: flex;
    align-items: center;
    width: 100px;

    .anticon {
      margin-right: 8px;
      font-size: 14px;
    }

    span {
      font-size: 14px;
    }
  }
}
</style>
